<template>
  <div id="Information" class="full_layout information">
    <h3 class="informationTitle">关于我们</h3>
    <div class="informationDetail">
      <img src="../../../static/images/image45.jpg">
      <div class="informationDetailList">
        <h2>DAKA达咖文化</h2>
        <p>达咖文化，又名DAKA，成立于2015年，是国内球星卡发行商，多年来一直专注于中国体育、娱乐、艺术、科学、历史等文化收藏产品创作和发行。目前为止，DAKA已为众多IP打造了数十款人气产品，例如曼城等国际顶级俱乐部、CBA等职业联赛、上海申花等中超俱乐部、《我和我的祖国》等影视作品、爱奇艺偶像练习生等娱乐综艺、以及中国拳王邹市明等收藏卡相关产品。 秉承着“收藏因为热爱”的理念，DAKA仍将继续深耕竞技体育收藏卡，创造更多受收藏迷喜爱的新产品，并积极开拓电竞、日韩娱乐、动漫等更多产品领域，更好的服务中国收藏玩家。</p>
      </div>
      <div class="informationDetailList">
        <h2>什么是球星卡？</h2>
        <p>交换收藏卡是一张卡片，通常由一张薄的或者厚的纸板做成，包含一个特定人物、地点、真实或虚拟物品，以及一段文字(评论、数据、轶事)来对图片做出简短的介绍。市面存在众多不同品种的卡片，卡片上通常镶嵌比赛中用过的球衣、球员签字甚至是人物的毛发等物料。 球星卡通常随机插放于卡包，再装入盒装，最后放置于箱内由有版权的球星卡公司发行。</p>
      </div>
      <el-image class="businessLicense" src="../../../static/images/businessLicense.jpg" :preview-src-list="['../../../static/images/businessLicense.jpg']"></el-image>
    </div>
  </div>
</template>
<script>
export default {
  name: 'about',
  components: {},
  data() {
    return {}
  },
  mounted() {},
  created() {},
  methods: {}
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/market.css";

.informationDetail p {
  line-height: 2;
}

.informationDetail img {
  margin: 10px 0 60px;
  width: 100%;
}

.informationDetailList p {
  text-indent: 2em;
}

.informationDetailList h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 40px;
}

.informationDetailList+.informationDetailList {
  margin-top: 60px;
}

.businessLicense {
  width: 475px;
  height: 330px;
  margin: 50px auto;
  display: block;
}

</style>



// WEBPACK FOOTER //
// src/pages/information/about.vue